import React from 'react';
import { SVGProps } from 'react';
import { clsx } from 'clsx';
import { IconProps, iconVariants } from '../icon';
import '../icon/icon.module.scss';
type Props = IconProps & Omit<SVGProps<SVGSVGElement>, keyof IconProps>;
const Padlock = React.forwardRef<SVGSVGElement, Props>(({ color, size, opacity = 1, className, ...props }, ref) => {
  const classes = clsx(
    iconVariants({
      color,
      size,
    }),
    className,
  );
  const style: React.CSSProperties = {
    '--opacity': opacity,
  };
  return React.cloneElement(
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={20} fill="none" viewBox="0 0 17 20" ref={ref} {...props}>
      <path
        stroke="currentColor"
        d="M8.62 12v2.5M1 7.927v10.391h15.24V7.928zm2.77 0C3.77 3.771 3.77 1 8.62 1s4.85 2.77 4.85 6.927z"
      />
      <path stroke="currentColor" d="M8.62 12.855a.693.693 0 1 0 0-1.386.693.693 0 0 0 0 1.386Z" />
    </svg>,
    {
      role: 'presentation',
      focusable: false,
      className: classes,
      'aria-hidden': true,
      style,
      ...props,
    },
  );
});
Padlock.displayName = 'Padlock';
export default Padlock;
